import React, { useState, useMemo } from "react";
import { useRacing } from "../context/RacingContext";
import { RunCard } from "../components/RunCard";
import { Search } from "lucide-react";

export default function History() {
  const { runs, loaded } = useRacing();
  const [q, setQ] = useState("");
  const [filter, setFilter] = useState("all");

  const filtered = useMemo(() => {
    return runs.filter((r) => {
      if (filter !== "all" && r.result !== filter) return false;
      if (!q.trim()) return true;
      const s = q.toLowerCase();
      return [r.track, r.raceClass, r.date, r.notes].some((v) => (v || "").toLowerCase().includes(s));
    });
  }, [runs, q, filter]);

  const filters = [
    { v: "all", l: "All" },
    { v: "win", l: "Wins" },
    { v: "loss", l: "Losses" },
    { v: "bye", l: "Byes" },
  ];

  return (
    <div className="mx-auto max-w-4xl space-y-5">
      <h1 className="font-head text-3xl font-black tracking-tighter">Run History</h1>

      <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
        <div className="relative flex-1">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-mt-mutedfg" />
          <input
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Search track, class, notes…"
            data-testid="history-search"
            className="w-full rounded-lg border border-mt-border bg-mt-card py-2.5 pl-9 pr-3 text-sm outline-none focus:border-mt-primary focus:ring-1 focus:ring-mt-primary"
          />
        </div>
        <div className="flex gap-1.5">
          {filters.map((f) => (
            <button
              key={f.v}
              onClick={() => setFilter(f.v)}
              data-testid={`filter-${f.v}`}
              className={`rounded-lg border px-3 py-2 text-sm font-semibold transition-colors ${
                filter === f.v ? "border-mt-primary bg-mt-primary text-white" : "border-mt-border bg-mt-card hover:border-mt-primary"
              }`}
            >
              {f.l}
            </button>
          ))}
        </div>
      </div>

      {!loaded ? (
        <p className="py-10 text-center text-mt-mutedfg">Loading…</p>
      ) : filtered.length === 0 ? (
        <div className="rounded-xl border border-dashed border-mt-border bg-mt-card p-10 text-center text-mt-mutedfg" data-testid="history-empty">
          No runs match your filter.
        </div>
      ) : (
        <div className="grid gap-3 md:grid-cols-2">
          {filtered.map((r, i) => <RunCard key={r.id} run={r} index={i} />)}
        </div>
      )}
    </div>
  );
}
